// Sipariş Havuzu (WMS) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.orderPool';

export const wmsOrderPoolGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Sipariş Havuzu nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'E-ticaret sitenizden, pazaryerlerinden ve elle girilen siparişler akıllı depoya bu havuzda düşer. Bekleyen siparişleri seçip iş emrine (toplama turuna) bağlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Depo'),
    stats: t(`${G}.regions.stats`, 'Durum kartları'),
    filters: t(`${G}.regions.filters`, 'Durum, Tip, arama, kaynak'),
    toolbar: t(`${G}.regions.toolbar`, 'İş Emrine Ata, Manuel Sipariş, ⋮'),
    table: t(`${G}.regions.table`, 'Sipariş listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Depoyu seçin, durum kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Sağ üstten akıllı depoyu seçin. Kartlar siparişleri durumlarına göre sayar: Bekleyen, Stok Bekliyor, İş Emrinde, Toplamada, Paketlemede, Paketlendi, Kargoda ile Tekli ve Çoklu. Bir durum kartına tıklamak listeyi o duruma süzer.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tekli: toplam 1 adet ürün içeren sipariş. Çoklu: 1\'den fazla adet içeren sipariş.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Siparişi bulun'),
      text: t(`${G}.s2.text`, '"Durum", "Tip" ve arama kutusuyla listeyi daraltın. Kaynak düğmeleri (Yeni Siparişler, E-Ticaret, Trendyol, Hepsiburada, N11, Pazarama, PttAVM) siparişin geldiği kanala göre süzer; "İş Emrindekiler" iş emrine bağlanmış siparişleri gösterir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Ayrıntıya bakın, gerekirse iptal edin'),
      text: t(`${G}.s3.text`, 'Göz simgesi sipariş ayrıntısını açar. Yalnız "Bekleyen" siparişte iptal simgesi görünür; onay verince sipariş iptal edilir ve İptal Yönetimi kuyruğuna düşer. Sipariş e-ticaret sitenizden geldiyse orada da iptal edilir.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s4.title`, '4. İş emri oluşturun'),
      text: t(`${G}.s4.text`, 'Yalnız "Bekleyen" siparişler işaretlenebilir. Siparişleri işaretleyip "Seçilenleri İş Emrine Ata"ya basın. Tekli ve çoklu karışıksa "Tekli İş Emri" ve "Çoklu İş Emri" diye ayrı düğmeler çıkar; değilse "İş Emri Oluştur". Rota, deponun varsayılan rota stratejisine göre belirlenir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Oluşan iş emri İş Emirleri sayfasında "Oluşturuldu" durumunda görünür; orada toplayıcı ve araba seçilip başlatılır.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. İş emri limitlerini ayarlayın'),
      text: t(`${G}.s5.text`, '⋮ menüsündeki "İş Emri Ayarları"nda Max Sipariş Sayısı, Max Toplam Ürün Adedi ve Max Toplam Desi girebilirsiniz. Seçtiğiniz siparişler bir limiti aşarsa sistem onları birden fazla iş emrine böler. Boş bırakılan limit uygulanmaz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Limitler bu tarayıcıda saklanır; başka bir bilgisayarda yeniden girmeniz gerekir.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Manuel sipariş ve e-ticaret aktarımı'),
      text: t(`${G}.s6.text`, '"Manuel Sipariş" havuza elle sipariş ekler (ayrıntılar pencerenin (i) rehberinde). "E-Ticaret → WMS" stokta olan ama havuza düşmemiş e-ticaret siparişlerini toplu olarak havuza aktarmayı dener. Sayfa açıkken N11 siparişleri de belirli aralıklarla kontrol edilip havuza aktarılır.'),
    },
  ],
});
